export const isDev = () => {
  const currentUrl = window.location.href;
  const urlIsDev = currentUrl.includes("localhost") || currentUrl.includes("myxline-fin.web.app");
    if (urlIsDev) {
      return true;
    } else {
      return false;
    }
};